"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Popover/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdom = require('react-dom'); var _reactdom2 = _interopRequireDefault(_reactdom);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
















const GAP = 4
const WINDOW_MARGIN = 8

/* The open popovers, the last opened last. One opened from inside another
 * (a calendar in a Schedule popover) takes Escape and outside presses
 * first, so only the top one closes. */
const openLayers = []
const isTopLayer = (el) => !!el && openLayers[openLayers.length - 1] === el

/* A dropdown layer (a time list, a calendar) in a portal above everything,
 * dialogs included, placed against the window like RowMenu: a dialog's
 * scrolling body would clip it, and its transform would move a fixed one.
 * It opens below the anchor, or above when there's more room there (capped
 * to the room, scrolling inside), follows the anchor on scroll and resize,
 * and closes on a pointer down outside or on Escape (the top one only, when
 * one opened inside another). That Escape's keyup,
 * or that press's click on a dialog's backdrop, is kept from the dialog
 * (Modal closes on either), so it closes only the popover. */
const Popover = ({
  anchorRef, onClose, align = 'left', placement = 'below', className, style, children, ...props
}) => {
  const ref = _react.useRef(null)
  const onCloseRef = _react.useRef.call(void 0, onClose)
  onCloseRef.current = onClose

  const place = _react.useCallback.call(void 0, 
    () => {
      const el = ref.current
      const anchor = _optionalChain([anchorRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.getBoundingClientRect, 'call', _3 => _3()])
      if (!el || !anchor) return
      el.style.maxHeight = ''
      el.style.overflowY = ''
      const { width, height } = el.getBoundingClientRect()
      const below = window.innerHeight - anchor.bottom - GAP - WINDOW_MARGIN
      const above = anchor.top - GAP - WINDOW_MARGIN
      const isAbove = placement === 'above'
        ? height <= above || above > below
        : height > below && above > below
      const room = Math.max(0, isAbove ? above : below)
      const shown = Math.min(height, room)
      const left = align === 'right' ? anchor.right - width : anchor.left
      el.style.top = `${isAbove ? anchor.top - GAP - shown : anchor.bottom + GAP}px`
      el.style.left = `${Math.max(WINDOW_MARGIN, Math.min(left, window.innerWidth - width - WINDOW_MARGIN))}px`
      // Scrolls only when capped: overflow would clip the content's shadow.
      if (height > room) {
        el.style.maxHeight = `${room}px`
        el.style.overflowY = 'auto'
      }
      el.dataset.placement = isAbove ? 'top' : 'bottom'
      el.style.visibility = 'visible'
    },
    [anchorRef, align, placement],
  )

  // Placed before it's painted, so it never shows at the corner first.
  _react.useLayoutEffect.call(void 0, place)

  _react.useEffect.call(void 0, 
    () => {
      const layer = ref.current
      if (!layer) return
      openLayers.push(layer)
      return () => { openLayers.splice(openLayers.indexOf(layer), 1) }
    },
    [],
  )

  _react.useEffect.call(void 0, 
    () => {
      let frame = 0
      const schedule = () => {
        cancelAnimationFrame(frame)
        frame = requestAnimationFrame(place)
      }
      const onPointerDown = (e) => {
        if (!isTopLayer(ref.current)) return
        const target = e.target 
        if (_optionalChain([ref, 'access', _4 => _4.current, 'optionalAccess', _5 => _5.contains, 'call', _6 => _6(target)]) || _optionalChain([anchorRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.contains, 'call', _9 => _9(target)])) return
        // A press on a dialog's backdrop closes only the popover, not the
        // dialog under it with what's been chosen there.
        if (_optionalChain([(e.target ), 'access', _10 => _10.closest, 'optionalCall', _11 => _11('.blm-modal--backdrop')]) === e.target) exports.swallowNext.call(void 0, 'click')
        onCloseRef.current('outside')
      }
      const onKeyDown = (e) => {
        if (e.key !== 'Escape' || e.defaultPrevented || !isTopLayer(ref.current)) return
        e.preventDefault()
        exports.swallowNext.call(void 0, 'keyup', 'Escape')
        onCloseRef.current('escape')
      }
      // Any scroll (the dialog's body, the page) may move the anchor.
      window.addEventListener('scroll', schedule, true)
      window.addEventListener('resize', schedule)
      document.addEventListener('pointerdown', onPointerDown, true)
      document.addEventListener('keydown', onKeyDown)
      // Its own size changes too, e.g. a calendar month with six weeks.
      const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(schedule)
      if (ref.current) _optionalChain([observer, 'optionalAccess', _12 => _12.observe, 'call', _13 => _13(ref.current)])
      return () => {
        cancelAnimationFrame(frame)
        window.removeEventListener('scroll', schedule, true)
        window.removeEventListener('resize', schedule)
        document.removeEventListener('pointerdown', onPointerDown, true)
        document.removeEventListener('keydown', onKeyDown)
        _optionalChain([observer, 'optionalAccess', _14 => _14.disconnect, 'call', _15 => _15()])
      }
    },
    [anchorRef, place],
  )

  return _reactdom2.default.createPortal(
    _react2.default.createElement('div', {
      ref: ref,
      className: _classBuilder2.default.call(void 0, 'blm-popover', className),
      style: { ...style, visibility: 'hidden' },
      ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}

      ,  children 
    ),
    document.body,
  )
}

/* Modal closes on Escape's keyup and on a backdrop click; stop the next one
 * at the window, in the capture phase, before it can. */
 const swallowNext = (type, key) => {
  const onEvent = (e) => {
    if (key && (e ).key !== key) return
    e.stopPropagation()
    stop()
  }
  const stop = () => {
    window.removeEventListener(type, onEvent, true)
    clearTimeout(timer)
  }
  // One that never comes (the window lost focus) mustn't eat a later one.
  const timer = setTimeout(stop, 1000)
  window.addEventListener(type, onEvent, true)
}; exports.swallowNext = swallowNext

exports. default = Popover
